import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayHour',
    standalone: false
})
export class DisplayHourPipe implements PipeTransform {
  transform(hour: string, clock: string): string {
    if (clock !== '12') return hour;

    const h = parseInt(hour, 10);
    const hour12 = (h % 12) || 12;
    const padded = hour12 < 10 ? '0' + hour12 : '' + hour12;
    return `${padded}`;
  }
}

@NgModule({
  declarations: [DisplayHourPipe],
  exports: [DisplayHourPipe]
})
export class DisplayHourPipeModule {}
